"use client";

import React from "react";
import { ZoomIn } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger, DialogTitle } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/signature_wedding_reception_luxury.png",
  alt: "The Sterling Wedding Reception",
  className: "col-span-2 row-span-2"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/corporate_gala_silver_decor.png",
  alt: "Corporate Gala Silver Decor",
  className: "col-span-1 row-span-1"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/bridal_portrait_ethereal_lavender.png",
  alt: "Bridal Portrait in Ethereal Light",
  className: "col-span-1 row-span-2"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/event_floral_arrangement_detail.png",
  alt: "Exquisite Floral Arrangement Detail",
  className: "col-span-1 row-span-1"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/luxury_table_setting_amethyst.png",
  alt: "Luxury Table Setting with Amethyst Accents",
  className: "col-span-2 row-span-1"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/signature_occasions_outdoor_soiree.png",
  alt: "Signature Occasions Outdoor Soiree",
  className: "col-span-1 row-span-1"
}];
export default function MomentsCaptured() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return <section data-section-id="223034" id="moments-captured" className="py-20 md:py-32 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-12 md:mb-20 transition-all duration-700 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-5xl font-bold mb-6 text-primary tracking-tight">
            Moments Captured
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-default tracking-wide">
            Explore the artistry of atmosphere. From intimate weddings to grand 
            corporate galas, witness how Signature Occasions transforms visions 
            into ethereal realities.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[150px] md:auto-rows-[250px] grid-flow-dense">
          {galleryImages.map((img, i) => <GalleryItem key={img.id} img={img} index={i} />)}
        </div>
      </div>
    </section>;
}
function GalleryItem({
  img,
  index
}: {
  img: (typeof galleryImages)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <Dialog>
      <DialogTrigger asChild data-index={index}>
        <div ref={ref} className={`relative overflow-hidden rounded-lg cursor-pointer group ${img.className} transition-all duration-700 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`} style={{
        transitionDelay: `${index * 100}ms`
      }}>
          <img src={img.src} alt={img.alt} className="object-cover w-full h-full transition-transform duration-1000 group-hover:scale-110" loading="lazy" />
          <div className="absolute inset-0 bg-primary/20 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col items-center justify-center p-4 text-center">
            <span className="font-serif text-white text-lg md:text-xl mb-2 drop-shadow-sm">
              {img.alt}
            </span>
            <ZoomIn className="text-white/80 size-6 drop-shadow-md" />
          </div>
        </div>
      </DialogTrigger>
      <DialogContent className="max-w-5xl w-[95vw] p-1 md:p-2 bg-background/95 backdrop-blur-md border-border shadow-4xl">
        <DialogTitle className="sr-only">{img.alt}</DialogTitle>
        <div className="relative w-full h-full max-h-[85vh] rounded-md overflow-hidden bg-muted flex items-center justify-center">
          <img src={img.src} alt={img.alt} className="w-full h-full max-h-[85vh] object-contain" />
        </div>
      </DialogContent>
    </Dialog>;
}